import styled from 'styled-components';

export const StyledImageWrapper = styled.section({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  overflow: 'hidden',
});
